export default __webpack_public_path__ + "static/media/post-04.124c0d5d.jpg";